import React from 'react'

interface Props {
  children: React.ReactNode
  size?: Size
  className?: string
}

function Typography({children, size = 'md', className = ''}: Props) {
  const styles = {
    xs: 'font-medium text-xs',
    sm: 'font-medium text-sm',
    sm2: 'font-medium text-sm md:text-base',
    md: 'font-medium text-base',
    md2: 'font-medium text-base md:text-lg',
    md3: 'font-medium text-base sm:text-lg md:text-xl',
    lg: 'text-xl',
    lg2: 'text-2xl md:text-3xl',
    lg3: 'text-3xl md:text-4xl',
    xl: 'text-3xl md:text-4xl lg:text-5xl ',
    xxl: 'font-medium text-3xl sm:text-4xl md:text-5xl lg:text-6xl ',
  }

  return <p className={` ${styles?.[size]} ${className}`}>{children}</p>
}

export default Typography
